// Neu (SPEC 03 §8.5.2) — Zahlen-, Anspruchs- und Datumsformat. Formatiert NUR, was die API
// liefert; entscheidet nie, OB ein Prozentwert gezeigt wird (`anteil === null` ist das Urteil
// des Servers über eine zu kleine Basis, 02 §3.8).
import type { Einheit } from "../api/typen";

export const nf = (n: number, d = 0) => n.toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d });
/** 0.475 → "48 %"; 0 < p < 0.005 → "< 1 %"; halbe Prozent werden aufgerundet (wie 02 §4.6). */
export function prozent(anteil: number): string {
  if (anteil > 0 && anteil < 0.005) return "< 1 %";
  // Über ganze Basispunkte gerechnet: der Server liefert `anteil` auf 4 Stellen (02 §3.9), und
  // 0.575 * 100 ergäbe in Gleitkomma 57,4999… → „57 %“ statt „58 %“.
  const bp = Math.round(anteil * 10000);
  return `${Math.floor((bp + 50) / 100)} %`;
}
const PLURAL = { kinder: ["Kind", "Kindern", "Kinder"], nennungen: ["Nennung", "Nennungen", "Nennungen"], boegen: ["Bogen", "Bögen", "Bögen"] } as const;
/** "19 von 40 · 48 %" | "3 von 7" (anteil null ⇒ Basis zu klein, 02 §3.8) | "19" (ohne Basis). */
export function anspruchText(z: { wert: number; basis?: number | null; anteil?: number | null; einheit?: Einheit }, mitEinheit = false): string {
  const e = z.einheit && mitEinheit ? PLURAL[z.einheit] : null;
  if (z.basis == null) return e ? `${nf(z.wert)} ${z.wert === 1 ? e[0] : e[2]}` : nf(z.wert);
  const kopf = `${nf(z.wert)} von ${nf(z.basis)}${e ? " " + e[1] : ""}`;
  return z.anteil == null ? kopf : `${kopf} · ${prozent(z.anteil)}`;
}
export const datum = (iso: string) => new Date(iso).toLocaleDateString("de-DE", { timeZone: "Europe/Berlin" });
export const datumZeit = (iso: string) => new Date(iso).toLocaleString("de-DE", { timeZone: "Europe/Berlin", dateStyle: "short", timeStyle: "short" });
export const uhrzeit = (iso: string) => new Date(iso).toLocaleTimeString("de-DE", { timeZone: "Europe/Berlin", hour: "2-digit", minute: "2-digit" });
/** "MU26-017-2c" → ["MU26-", "017-2c"] (Präfix blass, DESIGN §5). */
export function codeTeile(code: string): [string, string] { const m = /^([A-Z]{2,5}\d{2}-)(.*)$/.exec(code); return m ? [m[1]!, m[2]!] : ["", code]; }
